import {sdkTextElement, sdkMessageElement, localizeSdkElement} from '../../i18n/sdk-text';
import React from 'react';
import {createPortal} from 'react-dom';
import {aplusLateNotices} from '../../controllers/utilities/apluspay-late-notices';

// Mounted by the SDK Session wrapper, so notices survive SDK page navigation.
// A closed native WebView cannot render a popup; queued orders are checked when
// the authenticated SDK is opened/visible again.
export default class AplusLateNotices extends React.Component {
    constructor(props){super(props);this.state={notices:[]};this.wake=()=>aplusLateNotices().wake();}
    componentDidMount(){
        this.alive=true;this.watch();
        ['focus','pageshow','online','storage'].forEach(name=>window.addEventListener(name,this.wake));
        document.addEventListener('visibilitychange',this.wake);
    }
    componentDidUpdate(previous){
        const before=previous.session||{},after=this.props.session||{};
        if(before.accessToken!==after.accessToken||before.userId!==after.userId||previous.gameId!==this.props.gameId){this.setState({notices:[]});this.watch();}
    }
    componentWillUnmount(){
        this.alive=false;aplusLateNotices().stop();
        ['focus','pageshow','online','storage'].forEach(name=>window.removeEventListener(name,this.wake));
        document.removeEventListener('visibilitychange',this.wake);
    }
    watch(){
        const token=this.props.session&&this.props.session.accessToken,user=this.props.session&&this.props.session.userId,game=this.props.gameId;
        aplusLateNotices().watch(this.props,notice=>{
            if(this.alive&&token===(this.props.session&&this.props.session.accessToken)&&user===(this.props.session&&this.props.session.userId)&&game===this.props.gameId){
                this.setState(state=>state.notices.some(item=>item.requestId===notice.requestId)?null:{notices:[...state.notices,notice]});
            }
        });
    }
    render(){
        const notice=this.state.notices[0];if(!notice||typeof document==='undefined')return null;
        const method=notice.providerId==='antpay'?'支付寶':notice.providerId==='antpay3'?'微信支付':'信用卡';
        return createPortal(<div className="op-aplus-late-shade">
            <style>{`.op-aplus-late-shade{position:fixed;inset:0;top:0;right:0;bottom:0;left:0;z-index:2147483646;background:rgba(12,16,28,.65);display:flex;align-items:center;justify-content:center;padding:16px;box-sizing:border-box}.op-aplus-late-dialog{width:100%;max-width:480px;max-height:80vh;overflow:auto;box-sizing:border-box;border-radius:18px;background:#fff;padding:24px;color:#17212b;font:16px/1.5 sans-serif;text-align:left}.op-aplus-late-dialog h2{font-size:23px;line-height:1.35;margin:0 0 16px}.op-aplus-late-dialog p{margin:12px 0;overflow-wrap:anywhere}.op-aplus-late-dialog button{display:block;width:100%;min-height:48px;border:0;border-radius:10px;background:#b52b59;color:#fff;font-size:18px;margin-top:20px;padding:10px;cursor:pointer}.op-aplus-late-id{font-size:13px;color:#65717c}`}</style>
            {localizeSdkElement(<section className="op-aplus-late-dialog" role="dialog" aria-modal="true" aria-label="充值成功">
                <h2>{notice.scheduled ? sdkTextElement('付款成功，日卡已啟用') : sdkTextElement('充值成功，OP 幣已入帳')}</h2>
                <p>{notice.scheduled ? sdkMessageElement("\u8F03\u65E9\u63D0\u4EA4\u7684{{v0}}\u4ED8\u6B3E\u5DF2\u78BA\u8A8D\uFF0C\u79AE\u5305\u5DF2\u555F\u7528\u3002\u8D08\u9001 OP \u5E63\u6703\u6309\u79AE\u5305\u898F\u5247\u5206\u671F\u767C\u653E\u3002", {
      v0: method
    }) : sdkMessageElement("\u8F03\u65E9\u63D0\u4EA4\u7684{{v0}}\u4ED8\u6B3E\u5DF2\u78BA\u8A8D\uFF0COP \u5E63\u5DF2\u6210\u529F\u5165\u5E33\u3002", {
      v0: method
    })}</p>
                {Number.isSafeInteger(notice.totalGold) && notice.totalGold > 0 ? <p>{sdkMessageElement("{{v0}}{{v1}} OP \u5E63", {
      v0: notice.scheduled ? sdkTextElement('合共贈送 ') : sdkTextElement('合共獲得 '),
      v1: notice.totalGold.toLocaleString()
    })}</p> : null}
                {Number.isSafeInteger(notice.amountMinor) ? <p>{sdkMessageElement("\u4FE1\u7528\u5361\u5BE6\u969B\u6536\u53D6 \u6E2F\u5E63 {{v0}}", {
      v0: (notice.amountMinor / 100).toFixed(2)
    })}</p> : null}
                {notice.merchantOrderId ? <p className="op-aplus-late-id">{sdkMessageElement("\u5546\u6236\u8A02\u55AE\u865F\uFF1A{{v0}}", {
      v0: notice.merchantOrderId
    })}</p> : null}
                <button type="button" onClick={() => this.setState(state => ({
    notices: state.notices.slice(1)
  }))}>{sdkTextElement("\u77E5\u9053\u4E86")}</button>
            </section>, {
  "aria-label": ["\u5145\u503C\u6210\u529F"]
})}
        </div>,document.body);
    }
}
